
import axios from 'axios';
import authHeader from './auth-header'; // Asegúrate de que esto esté configurado

const API_URL = process.env.VUE_APP_API_BASE_URL;

export default {
    getUsers(pageUrl=null) {

        const queryString = new URLSearchParams(pageUrl).toString();
        const url = `${API_URL}/users?${queryString}`; 
        
        return axios.get(url, { headers: authHeader() });
    },
    getAll(pageUrl=null) {
        if (pageUrl === 'all') {
            const url = `${API_URL}/users?page=all`; 
            return axios.get(url, { headers: authHeader() });
        }
        const url = `${API_URL}/users?page=${pageUrl || 1}`; 
        return axios.get(url, { headers: authHeader() });
    },
    getUser(userId) {
        return axios.get(`${API_URL}/users/${userId}`, { headers: authHeader() });
    },
    createUser(userData) {
        return axios.post(`${API_URL}/users`, userData, { headers: authHeader() });
    },
    updateUser(userId, userData) {
        return axios.put(`${API_URL}/users/${userId}`, userData, { headers: authHeader() });
    },
    deleteUser(userId) {
        return axios.delete(`${API_URL}/users/${userId}`, { headers: authHeader() });
    },
    importClientsExcel(file) {
        const formData = new FormData();
        formData.append('file', file);
        return axios.post(`${API_URL}/users/import-clients-excel`, formData, {
            headers: {
                Authorization: authHeader().Authorization || '',
            },
        });
    },
    getOficios() {
        const url = `${API_URL}/oficios`; // Si pageUrl es null, usa la URL base
        return axios.get(url, { headers: authHeader() });
    },
};